import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import { Badge, Description } from "@mui/icons-material";
import rootStyles from "../styles.module.scss";
import styles from "./styles.module.scss";
import { clsx } from "@ismael1361/utils";
import { NotistackServices, UserServices } from "shared/services";
import { useAccount } from "shared/hooks";
import { isValidEmail, isValidUsername } from "shared/utils/Validate";

export const ProfilePage: React.FC = () => {
	const user = useAccount();
	const [loading, setLoading] = useState(false);
	const [firstName, setFirstName] = useState(UserServices.currentUser?.firstName || "");
	const [lastName, setLastName] = useState(UserServices.currentUser?.lastName || "");
	const [username, setUsername] = useState(UserServices.currentUser?.username || "");
	const [email, setEmail] = useState(UserServices.currentUser?.email || "");

	useEffect(() => {
		setFirstName(user?.firstName || "");
		setLastName(user?.lastName || "");
		setUsername(user?.username || "");
		setEmail(user?.email || "");
	}, []);

	const handleSaveChanges = async () => {
		setLoading(true);
		// Simulação de chamada de API para salvar as alterações
		try {
			const displayName = `${firstName.trim()} ${lastName.trim()}`;
			await UserServices.updateUser({ displayName, username, email });
			NotistackServices.showSuccessMessage("Alterações salvas com sucesso!");
		} catch (error) {
			NotistackServices.showErrorMessage("Ocorreu um erro ao salvar as alterações. Tente novamente.");
		}

		setLoading(false);
	};

	const isChanged = [firstName, lastName, username, email].join(",") !== [user?.firstName, user?.lastName, user?.username, user?.email].join(",");
	const isFormValid = firstName.trim() !== "" && lastName.trim() !== "" && isValidUsername(username) && isValidEmail(email);

	return (
		<div className={rootStyles.contentWrapper}>
			<div className={clsx(styles.avatarCard)}>
				<div className={styles.avatarContent}>
					<div
						className={styles.avatarImage}
						style={{
							backgroundImage: `url(${user?.profilePictureUrl})`,
						}}
					/>
					<div className={styles.avatarActions}>
						<p>Atualize sua foto de perfil para ser identificado facilmente.</p>
						<div className={styles.buttons}>
							<Button
								variant="contained"
								sx={{
									backgroundColor: "white",
									color: "black",
									borderRadius: "9999px",
									fontWeight: "bold",
									textTransform: "none",
								}}
								disabled
							>
								Alterar Foto
							</Button>
							<Button
								variant="outlined"
								sx={{
									color: "var(--mui-palette-text-secondary)",
									borderColor: "rgba(255, 255, 255, 0.1)",
									borderRadius: "9999px",
									fontWeight: "bold",
									textTransform: "none",
								}}
								disabled
							>
								Remover
							</Button>
						</div>
					</div>
				</div>
			</div>
			<section className={rootStyles.section}>
				<div className={rootStyles.card}>
					<h4 style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
						<Badge style={{ color: "var(--mui-palette-primary-main)" }} />
						Informações Pessoais
					</h4>
					<div className={rootStyles.formGrid}>
						<div className={rootStyles.row}>
							<TextField
								fullWidth
								label="Primeiro Nome"
								value={firstName}
								variant="outlined"
								autoComplete="first-name"
								onChange={(e) => setFirstName(e.target.value)}
								error={firstName.trim() === ""}
								helperText={firstName.trim() === "" ? "O primeiro nome é obrigatório." : " "}
							/>
							<TextField
								fullWidth
								label="Sobrenome"
								value={lastName}
								variant="outlined"
								autoComplete="last-name"
								onChange={(e) => setLastName(e.target.value)}
								error={lastName.trim() === ""}
								helperText={lastName.trim() === "" ? "O sobrenome é obrigatório." : " "}
							/>
						</div>
						<div>
							<TextField
								fullWidth
								label="Username"
								value={username}
								variant="outlined"
								autoComplete="username"
								onChange={(e) => setUsername(e.target.value)}
								error={username.trim() === ""}
								helperText={username.trim() === "" ? "O username é obrigatório." : " "}
							/>
						</div>
						<div>
							<TextField
								fullWidth
								label="E-mail"
								value={email}
								variant="outlined"
								type="email"
								autoComplete="email"
								onChange={(e) => setEmail(e.target.value)}
								error={isValidEmail(email) === false}
								helperText={isValidEmail(email) === false ? "O e-mail não é válido." : " "}
								disabled
							/>
						</div>
					</div>
				</div>

				{/* <div className={rootStyles.card}>
					<h4 style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
						<Description style={{ color: "var(--mui-palette-primary-main)" }} />
						Bio
					</h4>
					<div>
						<TextField
							fullWidth
							label="Descrição Profissional"
							placeholder="Fale um pouco sobre sua trajetória e expertise..."
							multiline
							rows={4}
							variant="outlined"
							disabled
						/>
					</div>
				</div> */}
			</section>

			<div style={{ display: "flex", justifyContent: "flex-end" }}>
				<Button
					variant="contained"
					color="primary"
					size="large"
					sx={{
						"borderRadius": "9999px",
						"padding": "1rem 2.5rem",
						"fontWeight": 800,
						"textTransform": "none",
						"boxShadow": "0 0 15px rgba(29, 185, 84, 0.3)",
						":disabled": {
							boxShadow: "none",
						},
					}}
					disabled={!isChanged || loading || !isFormValid}
					loading={loading}
					onClick={handleSaveChanges}
				>
					Salvar Alterações
				</Button>
			</div>
		</div>
	);
};
